import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { AppStateInterface } from '../../../../store/state/app.state';
import { combineLatest } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  hasSubscriptionSelector,
  userBalanceSelector,
} from '../../../../store/selectors/billing.selectors';
import { TicketInfoInterface } from '../models/ticket-info.interface';
import { MultiChatService } from '../../../../shared/services/multi-chat.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MultiChatNavigationCardComponent } from './multi-chat-navigation-card/multi-chat-navigation-card.component';

@Component({
  selector: 'app-multi-chat-navigation',
  templateUrl: './multi-chat-navigation.component.html',
  styleUrls: ['./multi-chat-navigation.component.scss'],
})
export class MultiChatNavigationComponent {
  @Input() tickets: Array<TicketInfoInterface> = [];

  @Input() ticketsCount: number = 0;

  @Input() showMore: boolean = false;

  @Output() newTaskCreated = new EventEmitter<any>();

  @Output() ticketChosen = new EventEmitter<TicketInfoInterface>();

  @Output() moreTicketsLoaded = new EventEmitter<any>();

  @ViewChildren('chatNavigationCardComponent')
  private chatNavigationCards!: QueryList<MultiChatNavigationCardComponent>;

  private userBalance: number = 0;

  private hasSubscription: boolean = false;

  chosenTicket: TicketInfoInterface | undefined = undefined;

  constructor(
    private store: Store<AppStateInterface>,
    private multiChatService: MultiChatService,
    private modalService: NgbModal,
  ) {
    combineLatest([
      this.store.select(userBalanceSelector),
      this.store.select(hasSubscriptionSelector),
    ]).subscribe(([userBalance, userHasSubscription]) => {
      this.userBalance = userBalance;
      this.hasSubscription = userHasSubscription;
    });
    this.multiChatService.userOutFromTicket$.subscribe((action) => {
      if (action) {
        this.chosenTicket = undefined;
      }
    });
  }

  public trackByFn(_index: any, item: any) {
    return item.id;
  }

  createNewTask() {
    if (this.checkAllowedTickets) {
      this.newTaskCreated.emit();
    } else {
      this.openBillingModal();
    }
  }

  chooseTicket(ticket: TicketInfoInterface) {
    const chosenTicketNavigationEl = this.chatNavigationCards
      .toArray()
      .find((t) => t.ticket.id === ticket.id);
    if (chosenTicketNavigationEl && !chosenTicketNavigationEl.status.topUpCoins) {
      this.ticketChosen.emit(ticket);
      this.chosenTicket = ticket;
    } else {
      this.openBillingModal();
    }
  }

  get checkAllowedTickets() {
    const activeTickets = this.tickets.filter((ticket) => ticket.status !== 'closed').length;
    const allowedTickets = this.userBalance - activeTickets;
    return allowedTickets > 0 && this.hasSubscription;
  }

  loadMoreTickets() {
    this.moreTicketsLoaded.emit();
  }

  private openBillingModal() {
    if (this.hasSubscription) {
      import('../../../../components/modals/billing-modal/billing-modal-component.module').then(
        ({ BillingModalComponentModule }) => {
          const BillingModalComponent = BillingModalComponentModule.getComponent();
          this.modalService.open(BillingModalComponent, {
            backdrop: 'static',
            keyboard: false,
          });
        },
      );
    } else {
      import('../../../../components/modals/plan-modal/plan-modal-component.module').then(
        ({ PlanModalComponentModule }) => {
          const PlanModalComponent = PlanModalComponentModule.getComponent();
          this.modalService.open(PlanModalComponent, {
            backdrop: 'static',
            keyboard: false,
          });
        },
      );
    }
  }
}
